/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsPermissionsSubListItem,
    ControlcenterMelcoModelsPermissionsSubListItemFromJSON,
    ControlcenterMelcoModelsPermissionsSubListItemFromJSONTyped,
    ControlcenterMelcoModelsPermissionsSubListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsUserProductAccess
 */
export interface ControlcenterMelcoModelsUserProductAccess {
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoModelsUserProductAccess
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsUserProductAccess
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsUserProductAccess
     */
    product_name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoModelsUserProductAccess
     */
    is_removable?: boolean;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsPermissionsSubListItem>}
     * @memberof ControlcenterMelcoModelsUserProductAccess
     */
    permissions?: Array<ControlcenterMelcoModelsPermissionsSubListItem> | null;
}

export function ControlcenterMelcoModelsUserProductAccessFromJSON(json: any): ControlcenterMelcoModelsUserProductAccess {
    return ControlcenterMelcoModelsUserProductAccessFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsUserProductAccessFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsUserProductAccess {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': !exists(json, 'active') ? undefined : json['active'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'product_name': !exists(json, 'product_name') ? undefined : json['product_name'],
        'is_removable': !exists(json, 'is_removable') ? undefined : json['is_removable'],
        'permissions': !exists(json, 'permissions') ? undefined : (json['permissions'] === null ? null : (json['permissions'] as Array<any>).map(ControlcenterMelcoModelsPermissionsSubListItemFromJSON)),
    };
}

export function ControlcenterMelcoModelsUserProductAccessToJSON(value?: ControlcenterMelcoModelsUserProductAccess | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
        'product_code': value.product_code,
        'product_name': value.product_name,
        'is_removable': value.is_removable,
        'permissions': value.permissions === undefined ? undefined : (value.permissions === null ? null : (value.permissions as Array<any>).map(ControlcenterMelcoModelsPermissionsSubListItemToJSON)),
    };
}


